import { Component, OnInit } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

import {PodcastItem} from "../../../editor/podcast-item";
import {TranslationService} from "../../../services/translation.service";


@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.css']
})
export class MainPageComponent implements OnInit {
  private
    list:PodcastItem;
    mode: string;

  constructor(
      private http: HttpClient,
      private router: Router,
      private route: ActivatedRoute,
      private translationService: TranslationService
  ) { }

  ngOnInit() {
      this.route.params.subscribe(params => {
          console.log('Route Params: ', params.mode);

          this.mode = params.mode ? params.mode : null;

          this.http
              .post('/list', params.mode ? { mode: params.mode } : {} ).subscribe(
              (result) => {
                  this.list = <PodcastItem>result;
              });
      });


  }

  go(podcast) {
      this.router.navigate(['view/' + podcast.id])
  }

  edit(podcast) {
      this.router.navigate(['editor/uploader/' + podcast.id])
  }
}